import produce from 'immer';
import create from 'zustand';

const useAnnouncementStore = create(set => ({
  announcement: {
    id: null,
    name: null,
    heroImage: null,
    heroImageFilename: null,
    heroImageContentType: null,
    heroImageUrl: null,
    headline: null,
    copy: null,
    buttonCopy: null,
    buttonLink: null,
    expiryDate: null,
    userGroup: null,
    companies: [],
    investorTypes: [],
    userType: 'all',
    enabledUserEmails: null,
  },
  userGroupOptions: [
    { label: 'Users', value: 'users' },
    { label: 'Contributors', value: 'contributors' },
  ],
  userTypeOptions: [
    { label: 'All Users', value: 'all' },
    { label: 'Logged In', value: 'logged_in' },
    { label: 'Logged Out', value: 'logged_out' },
    { label: 'User Emails', value: 'user_emails' },
  ],
  errors: {},
  set: fn => set(produce(fn)),
}));

export default useAnnouncementStore;
